import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-5" }
const _hoisted_3 = { class: "d-flex align-items-center landingSubtitle" }
const _hoisted_4 = { class: "pb-5" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_6 = { class: "form-floating mb-5" }
const _hoisted_7 = {
  disabled: "",
  value: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-label mb-3 required" }
const _hoisted_10 = { class: "form-floating mb-5" }
const _hoisted_11 = { class: "form-label mb-3 required" }
const _hoisted_12 = { class: "form-floating mb-5" }
const _hoisted_13 = { class: "form-label mb-3 required" }
const _hoisted_14 = {
  key: 0,
  class: "form-floating mb-5"
}
const _hoisted_15 = { class: "form-label mb-3 required" }
const _hoisted_16 = { class: "input-group mb-5" }
const _hoisted_17 = { class: "form-floating flex-grow-1" }
const _hoisted_18 = { class: "form-label mb-3 required" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-2x" })
], -1)
const _hoisted_20 = {
  key: 1,
  class: "input-group mb-5"
}
const _hoisted_21 = { class: "form-floating flex-grow-1" }
const _hoisted_22 = { class: "form-label mb-3 required" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-2x" })
], -1)
const _hoisted_24 = { class: "pt-8 pb-5" }
const _hoisted_25 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_26 = { class: "input-group mb-5" }
const _hoisted_27 = { class: "form-floating flex-grow-1" }
const _hoisted_28 = { class: "form-label mb-3 required" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border":"none"},
  class: "form-control-solid input-group-text"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-2x" })
], -1)
const _hoisted_30 = { class: "form-floating mb-5" }
const _hoisted_31 = { class: "form-label mb-3 required" }
const _hoisted_32 = { class: "form-floating mb-5" }
const _hoisted_33 = {
  disabled: "",
  value: ""
}
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "form-label mb-3" }
const _hoisted_36 = { class: "form-floating mb-5" }
const _hoisted_37 = {
  disabled: "",
  value: ""
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: "Huesca" }, "Huesca", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "Teruel" }, "Teruel", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "Zaragoza" }, "Zaragoza", -1)
const _hoisted_41 = { class: "form-label mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.i18n("paso1")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.i18n("FamiliaGroupLabel")), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("select", {
        name: "tratamiento",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event)),
        class: "form-select form-select-solid"
      }, [
        _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("OpcionInicialTratamiento")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
          return (_openBlock(), _createElementBlock("option", {
            value: tratamiento.id,
            key: i
          }, _toDisplayString(tratamiento.text), 9, _hoisted_8))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.tratamiento]
      ]),
      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("TratamientoLabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "tratamiento",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _withDirectives(_createElementVNode("input", {
        name: "nombre",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event)),
        type: "text",
        class: "form-control form-control-lg form-control-solid",
        placeholder: " "
      }, null, 512), [
        [_vModelText, _ctx.nombre]
      ]),
      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.i18n("FamiliaNombreLabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "nombre",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _withDirectives(_createElementVNode("input", {
        name: "apellidos",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event)),
        type: "text",
        class: "form-control form-control-lg form-control-solid",
        placeholder: " "
      }, null, 512), [
        [_vModelText, _ctx.apellidos]
      ]),
      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.i18n("FamiliaApellidosLabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "apellidos",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    (!_ctx.datosContacto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            name: "dni",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dni) = $event)),
            type: "text",
            class: "form-control form-control-lg form-control-solid",
            placeholder: " "
          }, null, 512), [
            [_vModelText, _ctx.dni]
          ]),
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.i18n("FamiliaDNILabel")), 1),
          _createVNode(_component_ErrorMessage, {
            name: "dni",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          id: "email",
          name: "email",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
          type: "email",
          class: "form-control form-control-lg form-control-solid",
          placeholder: "email@example.com"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.i18n("FamiliaEmailLabel")), 1)
      ]),
      _hoisted_19,
      _createVNode(_component_ErrorMessage, {
        name: "email",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    (!_ctx.datosContacto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              id: "telefono",
              name: "telefono",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telefono) = $event)),
              type: "tel",
              class: "form-control form-control-lg form-control-solid",
              placeholder: " "
            }, null, 512), [
              [_vModelText, _ctx.telefono]
            ]),
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.i18n("FamiliaTelefonoLabel")), 1)
          ]),
          _hoisted_23,
          _createVNode(_component_ErrorMessage, {
            name: "telefono",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.i18n("DireccionGroupLabel")), 1)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _withDirectives(_createElementVNode("input", {
          name: "direccion",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.direccion) = $event)),
          type: "text",
          class: "form-control form-control-lg form-control-solid",
          placeholder: " "
        }, null, 512), [
          [_vModelText, _ctx.direccion]
        ]),
        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.i18n("DireccionDireccionLabel")), 1)
      ]),
      _hoisted_29,
      _createVNode(_component_ErrorMessage, {
        name: "direccion",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.localidad,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localidad) = $event)),
        name: "localidad",
        class: "form-select form-select-solid form-el-select",
        filterable: "",
        placeholder: _ctx.i18n('OpcionInicialLocalidad'),
        "suffix-icon": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            disabled: "",
            value: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.i18n("OpcionInicialLocalidad")), 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.municipios, (municipio, i) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: i,
              value: municipio.municipioNombre
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(municipio.municipioNombre), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]),
      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.i18n("DireccionLocalidadLabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "localidad",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_32, [
      _withDirectives(_createElementVNode("select", {
        disabled: "",
        name: "comarca",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comarca) = $event)),
        class: "form-select form-select-solid form-select-display"
      }, [
        _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.i18n("OpcionInicialComarca")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (comarca, i) => {
          return (_openBlock(), _createElementBlock("option", {
            value: comarca.id,
            key: i
          }, _toDisplayString(comarca.text), 9, _hoisted_34))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.comarca]
      ]),
      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.i18n("DireccionComarcaLabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "comarca",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_36, [
      _withDirectives(_createElementVNode("select", {
        disabled: "",
        name: "provincia",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.provincia) = $event)),
        class: "form-select form-select-solid form-select-display"
      }, [
        _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.i18n("OpcionInicialProvincia")), 1),
        _hoisted_38,
        _hoisted_39,
        _hoisted_40
      ], 512), [
        [_vModelSelect, _ctx.provincia]
      ]),
      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.i18n("DireccionProvinciaLabel")), 1),
      _createVNode(_component_ErrorMessage, {
        name: "provincia",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}